function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.00287 2.68843V2.09001C9.00287 1.76142 9.33877 1.49358 9.7511 1.49358H13.9498C14.3631 1.49358 14.699 1.76142 14.699 2.09001V2.68843H9.00287ZM18.0973 4.181C18.0098 6.43629 17.4677 20.2548 17.3993 20.8771C17.3591 21.2495 17.2203 21.4327 17.1459 21.5064H6.5551C6.47967 21.4327 6.34189 21.2495 6.30167 20.8771C6.23429 20.2548 5.62786 6.44625 5.52931 4.181H18.0973ZM16.2015 2.68843V2.09C16.2015 0.936967 15.2592 0 14.0997 0H9.60128C8.44173 0 7.49941 0.936967 7.49941 2.09V2.68843H3V4.181H4.02579L4.8062 21.4198C4.81927 21.4835 5.15416 23 6.45048 23H17.2485C18.5458 23 18.8807 21.4835 18.9008 21.371L19.638 4.181H20.7V2.68843H16.2015ZM15.8956 5.37706H14.3921L13.9234 20.3118H15.4269L15.8956 5.37706ZM11.0981 20.312H12.6016V5.37726H11.0981V20.312ZM9.77641 20.3118L9.30776 5.37706H7.80427L8.27191 20.3118H9.77641Z",
  fill: "#979797"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/DeleteIcon.ab6f58ac.svg";
export { SvgComponent as ReactComponent };